import React, { Suspense } from 'react';
import EventCalendar from '../components/calendar/EventCalendar';
import Container from '../components/shared/container/Container';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageTitle from '../components/shared/page/PageTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';
import useFetchEvents from '../hooks/events/useFetchEvents';

const Events = () => {
  const { events } = useFetchEvents();
  return (
    <Suspense fallback={<CommonLoader />}>
      <section>
        <PageTitleContainer>
          <PageTitle title={'Календар'} />
        </PageTitleContainer>
        <Container>
          <EventCalendar events={events} />
        </Container>
      </section>
    </Suspense>
  );
};

export default Events;
